import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EDITOR_SERVICE } from '@core/injection-tokens/editor.injection.token';
import { TasksEffects } from '@modules/tasks/store/tasks.effects';
import { EffectsModule } from '@ngrx/effects';
import { SharedModule } from '@shared';
import { SharedDirectivesModule } from '@shared/directives';
import { TasksService } from '@shared/services/tasks.service';
import { MojoEditorModule } from 'mojo-editor';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { TasksContainerComponent } from './containers/tasks/tasks.container';
import { TasksListComponent } from './components/tasks-list/tasks-list.component';
import { TaskListItemComponent } from './components/task-list-item/task-list-item.component';
import { AddTaskItemComponent } from './components/add-task-item/add-task-item.component';
import { EditTaskItemComponent } from './components/edit-task-item/edit-task-item.component';
import { MojoPrivilegesModule } from 'mojo-privileges';
import { MojoFeatureExtensionsModule } from 'mojo-feature-extensions';
import { TasksPageContainerComponent } from '@modules/tasks/containers/tasks-page/tasks-page.container';
import { TasksDashboardContainerComponent } from './containers/tasks-dashboard/tasks-dashboard-container.component';
import { TasksSwimLaneComponent } from './components/tasks-swim-lane/tasks-swim-lane.component';
import { MojoAvatarModule } from 'mojo-avatar';
import { MojoInputModule } from '@shared/mojo-input/mojo-input.module';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { CandidateInputComponent } from '@shared/candidate-input/candidate-input.component';
import { MaterialModule } from '@material/material.module';
import { MojoTasksModule } from 'mojo-tasks';
import { TASKS_SERVICE } from '@core/injection-tokens/tasks.injection.token';

@NgModule({
  declarations: [
    TasksContainerComponent,
    TasksListComponent,
    TaskListItemComponent,
    AddTaskItemComponent,
    EditTaskItemComponent,
    TasksPageContainerComponent,
    TasksDashboardContainerComponent,
    TasksSwimLaneComponent,
    CandidateInputComponent,
  ],
  imports: [
    CommonModule,
    EffectsModule.forFeature([TasksEffects]),
    SharedModule,
    SharedDirectivesModule,
    MojoPrivilegesModule,
    MojoFeatureExtensionsModule,
    InfiniteScrollModule,
    MojoAvatarModule,
    MojoInputModule,
    MatAutocompleteModule,
    MaterialModule,
    MojoEditorModule.forRoot(EDITOR_SERVICE),
    MojoTasksModule.forRoot(TASKS_SERVICE),
  ],
  providers: [TasksService],
  exports: [TasksContainerComponent, TasksDashboardContainerComponent],
})
export class TasksModule {}
